// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from './Components/Navbar';
import Footer from './Components/Footer';

import About from './Pages/About';
import Contact from './Pages/Contact';
import Services from './Pages/Services';
import WhatsappLogo from "./Components/WhatsappLogo";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <main>
          <Routes>
            <Route path="/" element={<About />} />
            <Route path="/sobre" element={<About />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/servicos" element={<Services />} />
          </Routes>
        </main>
        <WhatsappLogo />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
